<template>
  <div>
    <div class="left">
      <!-- 
        Disabled make default button
      <div class="make-default">
        {{ $t('makeDefault') }}
        <button class="pin-btn" @click="changePin">
          <BaseIcon
            :name="active ? 'pinButton' : 'pinButtonGrey'"
            height="2.5rem"
            width="3rem"
          />
        </button>
      </div>
      -->
      <div class="select-os">
        <div class="heading">{{ $t('selectOS') }} :</div>
        <RexSelectV3
          @onChange="onOSChange"
          :options="getMobileOSsList"
          :value="getCurrentMobileOSLabel"
          id="select-search-mobile-os"
          :showSearch="false"
          :customStyle="{ width: '11.37rem' }"
        />
      </div>
      <div class="select-version">
        <div class="heading">{{ $t('selectAppVersion') }} :</div>
        <RexSelectV3
          @onChange="onAppVerChange"
          :value="getCurrentMobileAppVersionLabel"
          id="select-search-mobile-version"
          :showSearch="true"
          :filterOption="filterOption"
          :customStyle="{ width: '12.1rem' }"
        >
          <template #default>
            <RexSelectOption
              v-for="(obj, i) in getMobileAppVersionsList"
              :key="`${obj.value}-${i}`"
              :value="obj.label"
            >
              <RexTooltipV3
                :title="obj.label"
                placement="right"
                class="app-version-dropdown-opt-tooltip"
              >
                <div class="app-version-dropdown-opt-tooltip-text">
                  {{ obj.label }}
                </div>
              </RexTooltipV3>
            </RexSelectOption>
            <RexSelectOption :disabled="true" v-if="loading" key="loading">
              <div class="app-version-loading">
                <RexSpinV3 v-if="loading" size="small" />
              </div>
            </RexSelectOption>
          </template>
        </RexSelectV3>
      </div>
    </div>
  </div>
</template>

<script>
import RexSelectV3 from '@/rex-components/RexSelectV3.vue';
// import BaseIcon from '@/rex-components/BaseIcon.vue';
import { osTypes } from '@/components/Mobile/mobile.types';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { parseServiceObjFromApplication } from '@/utils/helper-function';
import RexSpinV3 from '@/rex-components/RexSpinV3.vue';
import RexTooltipV3 from '@/rex-components/RexTooltipV3.vue';
import { RexSelectOption } from '@/rex-components/rex.comp.config';

export default {
  components: {
    RexSelectV3,
    RexSpinV3,
    RexTooltipV3,
    RexSelectOption,
    // BaseIcon
  },
  data() {
    return {
      appsList: [],
      boldActive: true,
      osList: osTypes,
      osObjectIndex: 1,
      appVerSelected: {},
      appVerObjectIndex: 1,
      searchAppVer: this.$t('searchAppVersion'),
      loading: false,
    };
  },
  computed: {
    ...mapGetters('mobileState/mobileCommonState', [
      'getCurrentMobileService',
      'getCurrentMobileOS',
      'getCurrentMobileAppVersion',
      'getMobileAppVersions',
      'getMobileOSs',
    ]),
    ...mapGetters('globalState/settings', [
      'getDurationTime',
      'timezoneoffset',
    ]),
    ...mapGetters('globalState/user', { teamIdGetter: 'getTeamId' }),
    ...mapState('globalState/app', ['isForcastEnabled']),
    active() {
      return true;
    },
    getSelectedMobileService() {
      return this.getCurrentMobileService;
    },
    getCurrentMobileOSLabel() {
      return this.getCurrentMobileOS?.label ?? '';
    },
    getMobileOSsList() {
      return this.getMobileOSs.map((obj) => ({
        label: obj?.label,
        value: obj?.key,
      }));
    },
    getMobileAppVersionsList() {
      return this.getMobileAppVersions.map((obj) => ({
        label: obj?.label,
        value: obj?.key,
      }));
    },
    getCurrentMobileAppVersionLabel() {
      return this.getCurrentMobileAppVersion?.label ?? '';
    },
  },
  methods: {
    ...mapActions('mobileState/mobileCommonState', [
      'selectMobileService',
      'selectMobileOSs',
      'selectMobileCurrentAppVersion',
      'GET_MOBLIE_SERVICE_INSTANCES',
      'GET_OSs',
    ]),
    ...mapMutations('mobileState/mobileCommonState', ['setMobileAppVersion']),
    ...mapMutations('globalState/app', ['setIsForcastEnabled']),
    loadOSList() {
      this.GET_OSs(osTypes);
    },
    async getInstances(params) {
      try {
        this.setMobileAppVersion([]);
        this.loading = true;
        if (!params) {
          params = {
            duration: this.getDurationTime,
            serviceId: this.getSelectedMobileService.key,
          };
        }
        params.teamId = this.teamIdGetter;
        params.serviceId = Array.isArray(params.serviceId)
          ? 'all'
          : params.serviceId;
        await this.GET_MOBLIE_SERVICE_INSTANCES(params);
        this.loading = false;
      } catch (error) {
        console.log('error', error);
        this.loading = false;
      }
    },
    async onAppChange(option) {
      try {
        await this.selectMobileService(option);
        let params = {
          duration: this.getDurationTime,
          serviceId: option.key,
        };
        await this.getInstances(params);
      } catch (error) {
        console.log('error', error);
      }
    },
    changePin() {},
    async onOSChange(value, option) {
      const selectedOS = { key: option?.value, label: option?.label };
      await this.selectMobileOSs(selectedOS);
      if (selectedOS.key !== 'all') {
        this.setIsForcastEnabled(false);
      }
    },
    async onAppVerChange(value, option) {
      const key = option?.key?.split('-')?.[0];
      const selectedAppVer = { key, label: option?.value };
      await this.selectMobileCurrentAppVersion(selectedAppVer);
      if (selectedAppVer.key !== 'all') {
        this.setIsForcastEnabled(false);
      }
    },
    filterOption(input, option) {
      return option?.label
        ? option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        : false;
    },
  },
  async mounted() {
    this.loadOSList();
    this.getInstances();
  },
  created() {
    if (
      this.getCurrentMobileOS?.key !== 'all' ||
      this.getCurrentMobileAppVersion?.key !== 'all'
    ) {
      this.setIsForcastEnabled(false);
    }
  },
  watch: {
    getDurationTime() {
      this.getInstances();
    },
    isForcastEnabled(newVal, oldVal) {
      if (newVal === true) {
        this.selectMobileOSs(this.getMobileOSs[0]);
        this.selectMobileCurrentAppVersion(this.getMobileAppVersions[0]);
      }
    },
    getCurrentMobileService: async function (newVal) {
      const params = {
        duration: this.getDurationTime,
        serviceId: newVal.key,
      };
      await this.getInstances(params);
    },
  },
};
</script>

<style lang="scss" scoped>
.left {
  display: flex;
}
.select-appl {
  text-align: left;
  width: 28rem;
}
.select-os {
  @include flex-center-justify(flex-start);
  margin-left: 1.4rem;
}
.select-version {
  @include flex-center-justify(flex-start);
  margin-left: 1.3rem;
}
.make-default {
  @include flex-center;
  margin-left: 1rem;
  color: $font-primary;
}
.pin-btn {
  border: none;
  background: none;
  @include svg-fill-pointer($color-brand-accent);
}
.heading {
  @include heading-text;
  margin-right: 0.5625em;
}
.app-version-dropdown-opt-tooltip {
  overflow: hidden;
  white-space: nowrap;
}
.app-version-dropdown-opt-tooltip-text {
  @include truncate(false);
}
.app-version-loading {
  @include flex-center;
  height: 100%;
  width: 100%;
}
:deep(.search-sel .close-btn) {
  margin-right: 0.89em;
}
</style>
